import React, { useState, useCallback, memo } from 'react'
import { ScrollView, Text, TouchableOpacity, View } from 'react-native'
import { FormContentsModel, PerfectStoreTagsModel } from './models/StoreDetailModel'
import theme from '../../../theme'
import styles from './FormHorizontalTagsStyles'
import { colorFilterSelected, colorFilterUnselected } from '../../../themeConstants'
import { FormContent } from '../../services/interfaces/schedule.interface/schedule.getstore.interface'

export const FormHorizontalTags = ({
    tags,
    data,
    onClickTag,
    isSearch = false,
    fontWeight = 'bold',
    lowerCase = false,
}: {
    tags: PerfectStoreTagsModel[]
    data?: FormContentsModel[]
    onClickTag: (id: string, data?: FormContentsModel[]) => void
    isSearch?: boolean
    fontWeight?: '400' | '500' | '600' | '700' | 'bold'
    lowerCase?: boolean
}) => {
    const [selectedTag, setSelectedTag] = useState('-1')
    const onClick = useCallback(
        (id: string) => {
            setSelectedTag(id)
            onClickTag(id, data)
        },
        [onClickTag, data],
    )

    return (
        <ScrollView style={styles.scrollView} horizontal={true}>
            {tags.map((tag) => {
                const tagId = String(tag._id ?? '')
                const isSelected = selectedTag === tagId

                return (
                    <TagItem
                        key={tagId}
                        name={tag.name}
                        id={tagId}
                        data={data}
                        onClickTag={onClick}
                        isSelected={isSelected}
                        isSearch={isSearch}
                        fontWeight={fontWeight}
                        lowerCase={lowerCase}
                    />
                )
            })}
        </ScrollView>
    )
}

export const TagItem = memo(function TagItem({
    name,
    id,
    data,
    onClickTag,
    isSelected,
    isSearch,
    fontWeight = 'bold',
    lowerCase = false,
}: {
    name: string
    id: string
    data?: FormContentsModel[]
    onClickTag: (id: string) => void
    isSelected: boolean
    isSearch?: boolean
    fontWeight?: '400' | '500' | '600' | '700' | 'bold'
    lowerCase?: boolean
}) {
    let text = lowerCase ? name.capitalize() : name
    return (
        <View style={styles.containerLabels}>
            <TouchableOpacity
                onPress={() => onClickTag(id)}
                style={[
                    styles.flatFlagsPrimary,
                    {
                        backgroundColor: isSelected ? colorFilterSelected : 'white',
                        borderColor: isSelected
                            ? colorFilterSelected
                            : colorFilterUnselected,
                    },
                    isSearch && {
                        borderRadius: 20,
                        borderColor: isSelected
                            ? colorFilterSelected
                            : theme.colors.inputPlaceholder,
                    },
                ]}
            >
                <Text
                    style={[
                        isSelected
                            ? styles.flatItemsSelectedPrimary
                            : styles.flatItemsUnselectedPrimary,
                        { fontWeight },
                        isSearch && { fontWeight: '600' },
                    ]}
                >
                    {text}
                </Text>
            </TouchableOpacity>
        </View>
    )
})
